import Auth0Session from 'client/services/auth0-session';

const startAuth0Session = async () => {
  Auth0Session.initialize();
};

export default startAuth0Session;
